import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "../../../../core/user.service";
import { AlertService } from "../../../../_services/alert.service";
import { ToastrService } from 'ngx-toastr';
import { CqmnsProjectPopupComponent } from "../../../../_models/cqmns-project-popup/cqmns-project-popup.component";
import {MatDialog, MatDialogConfig} from "@angular/material";
import { AuthService } from "../../../../core/auth/auth.service";

@Component({
  selector: 'app-cqmns-approved-defect',
  templateUrl: './cqmns-approved-defect.component.html',
  styleUrls: ['./cqmns-approved-defect.component.css']
})
export class CqmnsApprovedDefectComponent implements OnInit {
  p: any;
  hostUrl = this.userService.getUrl();
  projectId: any;
  issues: any;
  approvedIssues: any;
  value = "select";
  message: any;
  source: any = [];
  userId: any;
  constructor(
    private toastr: ToastrService,
    private alertService: AlertService, 
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private matDialog: MatDialog,
    private authService: AuthService, 
  ) {}
  oldField = "";
  order = true;
  sortreview_date = "fa fa-sort";
  sortDescription = "fa fa-sort";
  sortautoClassification = "fa fa-sort";
  sortapprovedClassification = "fa fa-sort";
  sortautoAssign = "fa fa-sort";
  sortapprovedAssign = "fa fa-sort";
  project: any;
  projectName: any;
  isDesc = false;
  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
      this.userId = localStorage.getItem("userid");
   // this.projectId = this.route.snapshot.params["projectId"];
    this.projectId = localStorage.getItem("projectId");
    this.http
      .get(
        encodeURI(
          this.hostUrl + "/api/issue/bystatus/" + this.projectId + "/1/1"
        )
      )
      .subscribe(data => {
         this.approvedIssues = data;
      });
    // this.http
    //   .get(
    //     encodeURI(
    //       this.hostUrl + "/api/issue/sourceClassification/" + this.projectId
    //     )
    //   )
    //   .subscribe(data => {
    //     this.message = data;
    //     for (let i = 0; i <= this.message.length; i++) {
    //       this.source = this.message[i].source;
    //       console.log(this.source)
    //     }
    //   });
    this.http
      .get(
        encodeURI(
          this.hostUrl + "/api/issue/activatedProjects/" + this.projectId
        )
      )
      .subscribe(data => {
        this.project = data;
        for (let i = 0; i <= this.project.length; i++) {
          if(this.project[i]){
          this.projectName = this.project[i].project_name;
          }
        }
      });
  }

  onDone() {
    const url = "/cqm-ns/" + this.projectId;
    this.router.navigate([url]);
  }

  onchange(value) {
    this.value = value;
  }

  add(id) {
    let classi = "";
    let des = "";
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    if (this.value === "select") {
      const updateBody = { classificationType: "0", ApprovalStatus: "1" };
      this.http
        .post(
          encodeURI(this.hostUrl + "/api/issue/update/" + id.toString()),
          updateBody,
          { observe: 'response',             
            headers: headers }
        )
        .subscribe(data => {
          this.issues = data;
          for (let i = 0; i < this.issues.length; i++) {
            if (this.issues[i].ISSUEID === id) {
              this.issues.splice(i, 1);
            }
          }
          console.log(data["status"]);
          if (data["status"] === 200) {
            this.toastr.success('Retrained Successfully', 'Success ', {
              timeOut: 2000
            });
          } else {
            this.toastr.error('Something went wrong', 'Error ', {
              timeOut: 2000
            });
          }
        });
    } else {
      let updateBody = {};
      updateBody = {
        classificationType: "1",
        ApprovalStatus: "1",
        approvedClassification: this.value
      };
      this.http
        .post(
          encodeURI(this.hostUrl + "/api/issue/update/" + id.toString()),
          updateBody,
          { observe: 'response', 
            headers: headers }
        )
        .subscribe(data => {
          this.issues = data;
          for (let i = 0; i < this.issues.length; i++) {
            if (this.issues[i].ISSUEID === id) {
              classi += this.issues[i].autoClassification;
              des += this.approvedIssues[i].Description;
              this.issues.splice(i, 1);
            }
          }
          console.log(data["Status"]);
          if (data["status"] === 200) {
            this.toastr.success('Updated Successfully', 'Success ', {
                      timeOut: 2000
                    });
           this.alertService.success("Retrained Successfully");
          } else {
            this.toastr.error('Something went wrong', 'Error ', {
                      timeOut: 2000
                    });
           // this.alertService.error("Something went wrong");
          }
          this.http
            .post(
              encodeURI(
                this.hostUrl +
                  "/api/jira/changeLabel/" +
                  id.toString() +
                  "/" +
                  classi.toString()
              ),
              updateBody,
              { headers: headers }
            )
            .subscribe();
        });

      this.http
        .get(encodeURI(this.hostUrl + "/api/engine/retrain/" + id.toString()))
        .subscribe();
    }
    this.value = "select";
  }
  projectPopup() {
    

    const dialogConfig = new MatDialogConfig();

    // dialogConfig.panelClass = "login-modalbox";
  
    dialogConfig.backdropClass = 'popupBackdropClass';
  
    dialogConfig.maxHeight = window.innerHeight - 20 + 'px' ; 
  
    dialogConfig.panelClass = "ns-modalbox";
    dialogConfig.disableClose = false;
    this.matDialog.open(CqmnsProjectPopupComponent, dialogConfig);
  

}
  sortBy(field) {
    if (this.oldField == field) {
      this.isDesc = !this.isDesc;
      this.order = !this.order;
    } else {
      this.isDesc = false;
      this.order = false;
      this.oldField = field;
    }
    if (this.order) {
      field = "-" + field;
    }
    if (field === "review_date" || field === "-review_date") {
      this.sortreview_date = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
      this.sortDescription = "fa fa-sort";
      this.sortautoClassification = "fa fa-sort";
      this.sortapprovedClassification = "fa fa-sort";
      this.sortautoAssign = "fa fa-sort";
      this.sortapprovedAssign = "fa fa-sort";
    } else if (field === "Description" || field === "-Description") {
      this.sortDescription = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
      this.sortreview_date = "fa fa-sort";
      this.sortDescription = "fa fa-sort";
      this.sortautoClassification = "fa fa-sort";
      this.sortapprovedClassification = "fa fa-sort";
      this.sortautoAssign = "fa fa-sort";
      this.sortapprovedAssign = "fa fa-sort";
    } else if (
      field === "autoClassification" ||
      field === "-autoClassification"
    ) {
      this.sortautoClassification = this.isDesc
        ? "fa fa-sort-desc"
        : "fa fa-sort-asc";
      this.sortreview_date = "fa fa-sort";
      this.sortDescription = "fa fa-sort";
      this.sortautoClassification = "fa fa-sort";
      this.sortapprovedClassification = "fa fa-sort";
      this.sortautoAssign = "fa fa-sort";
      this.sortapprovedAssign = "fa fa-sort";
    } else if (
      field === "approvedClassification " ||
      field === "-approvedClassification"
    ) {
      this.sortapprovedClassification = this.isDesc
        ? "fa fa-sort-desc"
        : "fa fa-sort-asc";
      this.sortreview_date = "fa fa-sort";
      this.sortDescription = "fa fa-sort";
      this.sortautoClassification = "fa fa-sort";
      this.sortapprovedClassification = "fa fa-sort";
      this.sortautoAssign = "fa fa-sort";
      this.sortapprovedAssign = "fa fa-sort";
    } else if (field === "autoAssign" || field === "-autoAssign") {
      this.sortautoAssign = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
      this.sortreview_date = "fa fa-sort";
      this.sortDescription = "fa fa-sort";
      this.sortautoClassification = "fa fa-sort";
      this.sortapprovedClassification = "fa fa-sort";
      this.sortautoAssign = "fa fa-sort";
      this.sortapprovedAssign = "fa fa-sort";
    } else if (field === "approvedAssign" || field === "-approvedAssign") {
      this.sortapprovedAssign = this.isDesc
        ? "fa fa-sort-desc"
        : "fa fa-sort-asc";
      this.sortreview_date = "fa fa-sort";
      this.sortDescription = "fa fa-sort";
      this.sortautoClassification = "fa fa-sort";
      this.sortapprovedClassification = "fa fa-sort";
      this.sortautoAssign = "fa fa-sort";
      this.sortapprovedAssign = "fa fa-sort";
    }
    this.approvedIssues = this.approvedIssues.sort(
      this.userService.dynamicSort(field)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-actions/cqmns-approved-defect/cqmns-approved-defect.component.ts